module.exports = __webpack_public_path__ + "img/nho_hoac_bang.af28eea3.svg";